import { atomWithStorage } from "jotai/utils";

const sessionStorageNumberSync = {
	getItem: (key: string): number | null => {
		const storedValue = sessionStorage.getItem(key);
		return storedValue !== null ? Number(storedValue) : null;
	},
	setItem: (key: string, value: number | null) => {
		if (value !== null) {
			sessionStorage.setItem(key, String(value));
		} else {
			sessionStorage.removeItem(key);
		}
	},
	removeItem: (key: string) => {
		sessionStorage.removeItem(key);
	},
};

export const filteredUserIdAtom = atomWithStorage<number | null>(
	"filteredUserId",
	null,
	sessionStorageNumberSync,
);
